import script from "./GalleryComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./GalleryComponent.vue?vue&type=script&lang=ts&setup=true"

import "./GalleryComponent.vue?vue&type=style&index=0&id=01512a63&lang=scss"

const __exports__ = script;

export default __exports__